export default __webpack_public_path__ + "static/media/tour-7.8d340786.png";